export default "__VITE_ASSET__DyKuFbof__"